/**
 * A video that will not play stops being shown, and Agilite Media is told.
 *
 * WHY THIS EXISTS. Videos do not stay available: an uploader deletes one,
 * makes it private, or blocks a country, long after we checked it. The
 * library re-checks on a rotation, but between sweeps a shopper can still
 * meet a black frame reading "This video is unavailable" on a product page
 * (Dorian 2026-09-03: "How those can be possible?? PREVENT IT!! and make
 * that we remove this bad content from AM when it's happening").
 *
 * WHAT IT DOES. YouTube's own player says when it fails: with enablejsapi
 * on - which the flow already sets - it posts an `onError` message to the
 * page. Two things follow.
 *
 *   1. The card is taken off the screen at once, so the shopper does not sit
 *      looking at a dead frame while anything else happens.
 *   2. Agilite Media is told which record it was. It does NOT take our word
 *      for it: the server asks YouTube itself and acts on that answer, so
 *      this report can only ever start a verification, never hide something
 *      that actually plays.
 *
 * ISOLATION. Its own file, its own listener. It reads the stamps the flow
 * already puts on its cards (`data-agmf-id`) and changes nothing inside the
 * flow, so the feed can go on re-dealing itself however it likes.
 *
 * WHICH CODES COUNT. 100 (gone or private) and 101/150 (the uploader does
 * not allow embedding) are permanent facts about the video. 2 (bad
 * parameter) and 5 (the player's own HTML5 error) are about THIS attempt and
 * are left alone - retrying is the right answer to those, not removal.
 */
(function () {
  'use strict';

  var AM = (window.__AGMF_API_BASE || 'https://agilite-media-432657747828.europe-west1.run.app/')
    .replace(/\/?$/, '/');

  // Permanent facts about the video, as opposed to this attempt at it.
  var GONE = { 100: 'gone or private', 101: 'embedding not allowed', 150: 'embedding not allowed' };

  // One report per record per page. A player can fire onError repeatedly.
  var told = Object.create(null);

  function report(mediaId, why) {
    if (!mediaId || told[mediaId]) return;
    told[mediaId] = true;
    try {
      fetch(AM + 'api/feed/unplayable', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // No cookie, no key: the server verifies with YouTube before it
        // believes anything, so there is nothing here worth stealing.
        body: JSON.stringify({ mediaId: mediaId, why: why || '' }),
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  /** Take the dead card off the screen, and move the feed along if it was current. */
  function retire(card) {
    if (!card || card.__agmfDead) return;
    card.__agmfDead = true;
    card.setAttribute('data-agmf-dead', '1');
    card.style.display = 'none';
    try {
      // The flow owns the deck; tell it something left rather than reaching in.
      card.dispatchEvent(new CustomEvent('agmf:retired', {
        bubbles: true,
        detail: { reason: 'video unavailable' },
      }));
    } catch (e) {}
  }

  function errorCodeOf(data) {
    // Two shapes in the wild: a plain onError event, and an infoDelivery
    // carrying an errorCode. Either is the player saying it failed.
    if (data && data.event === 'onError') return Number(data.info);
    if (data && data.info && data.info.errorCode != null) return Number(data.info.errorCode);
    return NaN;
  }

  window.addEventListener('message', function (event) {
    if (typeof event.data !== 'string' || event.data.charAt(0) !== '{') return;
    if (String(event.origin).indexOf('youtube') === -1) return;
    var data;
    try { data = JSON.parse(event.data); } catch (e) { return; }
    var code = errorCodeOf(data);
    if (!GONE[code]) return;

    var frames = document.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow !== event.source) continue;
      var card = frames[i].closest('[data-agmf-id]');
      if (!card) return;
      report(card.getAttribute('data-agmf-id'), GONE[code]);
      retire(card);
      return;
    }
  });
})();
